import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-select-app-launch-type-confirm-dialog',
    templateUrl: './select-app-launch-type-confirm-dialog.component.html',
    styleUrl: './select-app-launch-type-confirm-dialog.component.scss',
    standalone: false
})
export class SelectAppLaunchTypeConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SelectAppLaunchTypeConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }
}
